import * as React from "react";
import { forwardRef } from "react";
const SvgIconEmoji = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16.001, height: 16.001, viewBox: "0 0 16.001 16.001", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 4a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8m0 1.333A6.667 6.667 0 1 1 5.333 12 6.657 6.657 0 0 1 12 5.333m-3 4a1 1 0 1 0 1 1 1 1 0 0 0-1-.999zm6 0a1 1 0 1 0 1 1 1 1 0 0 0-1-.999zM8.542 14l-1.142.667a5.308 5.308 0 0 0 9.209 0L15.459 14a3.99 3.99 0 0 1-6.917 0", "data-name": "icon/emoji", transform: "translate(-4 -4)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconEmoji);
export { ForwardRef as ReactComponent };
